import React from "react";
import { injectIntl } from "react-intl";

import TabList from "../components/UI/TabList";

const PageTemplate = ({ intl, ...props }) => {
  return <>{props.type === "tabs" && <TabList {...props} />}</>;
};

export default React.memo(injectIntl(PageTemplate));
